import React from "react";

const StatusBar = () => {
    return <div className='flex bg-main-600 px-8 py-5 uppercase tracking-wider	'>Home</div>;
};

export default StatusBar;
